<template>
    <default-modal
        v-if="open"
        @close="close"
        maxWidthClass="max-w-2xl w-full overflow-visible"
    >
        <h3
            slot="header"
            class="text-left text-xl leading-6 font-medium text-gray-800 pb-5 px-4"
        >
            Modifier un notaire pour
            <span class="font-bold text-blue-900">{{
                promotion ? promotion.title : '-'
            }}</span>
        </h3>
        <div slot="body" v-if="editedNotary" class="grid grid-cols-2 gap-x-6 gap-y-2 px-4">
            <div class="mt-3">
                <div class="text-left">
                    <label
                        for="first_name"
                        class="block text-sm font-medium leading-5 text-gray-700 mb-2"
                        >Prénom*</label
                    >
                    <input
                        type="text"
                        id="first_name"
                        v-model="editedNotary.first_name"
                        class="form-input w-full"
                    />
                </div>
            </div>

            <div class="mt-3">
                <div class="text-left">
                    <label
                        for="last_name"
                        class="block text-sm font-medium leading-5 text-gray-700 mb-2"
                        >Nom*</label
                    >
                    <input
                        type="text"
                        id="last_name"
                        v-model="editedNotary.last_name"
                        class="form-input w-full"
                    />
                </div>
            </div>

            <div class="mt-3">
                <div class="text-left">
                    <label
                        for="email"
                        class="block text-sm font-medium leading-5 text-gray-700 mb-2"
                        >Email*</label
                    >
                    <input
                        type="email"
                        id="email"
                        v-model="editedNotary.email"
                        class="form-input w-full"
                    />
                </div>
            </div>

            <div class="mt-3">
                <div class="text-left">
                    <label
                        for="phone"
                        class="block text-sm font-medium leading-5 text-gray-700 mb-2"
                        >Téléphone</label
                    >
                    <input
                        type="text"
                        id="phone"
                        v-model="editedNotary.phone"
                        class="form-input w-full"
                    />
                </div>
            </div>

            <div class="mt-3">
                <div class="text-left">
                    <label
                        for="iban"
                        class="block text-sm font-medium leading-5 text-gray-700 mb-2"
                        >IBAN</label
                    >
                    <input
                        type="text"
                        id="iban"
                        v-model="editedNotary.iban"
                        class="form-input w-full"
                    />
                </div>
            </div>

            <div class="mt-3">
                <div class="text-left">
                    <label
                        for="bank_name"
                        class="block text-sm font-medium leading-5 text-gray-700 mb-2"
                        >Nom de la banque</label
                    >
                    <input
                        type="text"
                        id="bank_name"
                        v-model="editedNotary.bank_name"
                        class="form-input w-full"
                    />
                </div>
            </div>

            <div class="mt-3">
                <div class="text-left">
                    <label
                        for="bank_holder"
                        class="block text-sm font-medium leading-5 text-gray-700 mb-2"
                        >Bénéficiaire du compte</label
                    >
                    <input
                        type="text"
                        id="bank_holder"
                        v-model="editedNotary.bank_holder"
                        class="form-input w-full"
                    />
                </div>
            </div>

            <div class="mt-3">
                <div class="text-left">
                    <label
                        for="address"
                        class="block text-sm font-medium leading-5 text-gray-700 mb-2"
                        >Adresse</label
                    >
                    <input
                        type="text"
                        id="adress"
                        v-model="editedNotary.address"
                        class="form-input w-full"
                    />
                </div>
            </div>

            <div class="mt-3">
                <div class="text-left">
                    <label
                        for="zip"
                        class="block text-sm font-medium leading-5 text-gray-700 mb-2"
                        >Code postal</label
                    >
                    <input
                        type="text"
                        id="zip"
                        v-model="editedNotary.zip"
                        class="form-input w-full"
                    />
                </div>
            </div>

            <div class="mt-3">
                <div class="text-left">
                    <label
                        for="city"
                        class="block text-sm font-medium leading-5 text-gray-700 mb-2"
                        >Ville</label
                    >
                    <input
                        type="text"
                        id="city"
                        v-model="editedNotary.city"
                        class="form-input w-full"
                    />
                </div>
            </div>


        </div>

        <div slot="footer" class="mt-12 text-right px-4">
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <span
                    class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
                >
                    <button
                        @click="submit"
                        type="button"
                        :disabled="!isValid"
                        class="inline-flex justify-center w-full rounded-md border border-gray-300 px-8 py-2 text-base leading-6 font-medium shadow-sm transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                        :class="submitButtonClass"
                    >
                        Valider
                    </button>
                </span>
                <span
                    class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
                >
                    <button
                        @click="close"
                        type="button"
                        class="inline-flex justify-center w-full rounded-md border border-gray-300 px-8 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        Fermer
                    </button>
                </span>
            </div>
        </div>
    </default-modal>
</template>

<script>
import DefaultModal from "@/components/global/modals/DefaultModal";

export default {
    components: {
        DefaultModal,
    },

    props: {
        open: {
            type: Boolean,
            required: true
        },

        promotion: {
            type: Object,
            required: true
        },

        notary: {
            type: Object,
            nullable: true
        }
    },

    data() {
        return this.initialState();
    },

    computed: {
        isValid() {
            if (this.isDisabled) {
                return false;
            }
            const fields = ["first_name", "last_name", "email"];
            for (const field of fields) {
                if ([null, ""].includes(this.notary[field])) {
                    return false;
                }
            }
            return true;
        },

        submitButtonClass() {
            return this.isValid
                ? "bg-blue-400 hover:bg-blue-600 text-gray-100 cursor-pointer"
                : "bg-gray-300 text-gray-700 cursor-not-allowed";
        },
    },
    methods: {
        initialState(){
            return  {
                editedNotary: null,
                isDisabled: false,
            };
        },
        reset(){
            Object.assign(this.$data, this.initialState());
        },
        close() {
            this.$emit("close");
        },

        submit() {
            this.isDisabled = true;
            this.$emit("submit", this.editedNotary);
            this.isDisabled = false;
            this.reset();
        },
    },
    watch: {
        open(val) {
            if(val){
                this.editedNotary = this.notary;
            }
        }
    }
};
</script>
